import invariant from 'invariant';
import { createContext, useContext } from 'react';

export interface FallbackScreenContext {
  size: 'small' | 'medium' | 'large';
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const fallbackScreenContext = createContext<FallbackScreenContext>(undefined!);

export const useFallbackScreen = () => {
  const context = useContext(fallbackScreenContext);
  invariant(context, 'useFallbackScreen should only be used inside FallbackScreen component');
  return context;
};

export interface FallbackScreenProps {
  variant: 'loading' | 'error' | 'empty';
  size: 'small' | 'medium' | 'large';
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}
